import React from 'react'
import './navbar.css'
import { BiLogOut } from 'react-icons/bi'
import { auth, firestore } from '../../firebase/config'
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { collection } from 'firebase/firestore'

const Navbar = ({userPhoto, getDocID}) => {
  const contactRef = collection(firestore, "chats");
  const [contacts] = useCollectionData(contactRef, {idField: 'id'});

  const selectContact = (contact) => { getDocID(contact.id) }

  const Contact = ({contact}) => (
    <div className='contact' onClick={() => selectContact(contact)}>
      <img src={contact.photoURL} alt='contact_photo' className='app__photo-icon' />
      <h1 className='app__contact-title'>{contact.title}</h1>
    </div>
  )

  return (
    <div className='navbar'>
      <header className='navbar__header'>
        <img src={userPhoto} alt='profile_photo' className='app__photo-icon'/>
        <div>
          <BiLogOut className='app__icon' onClick={() => auth.signOut()}/>
        </div>
      </header>

      <section className='navbar__contact'>
        {
          contacts  && contacts.map((index, id) => (
            <Contact key={id} contact={index.room}/>
          ))
        }
      </section>
    </div>
  )
}

export default Navbar